/**
 * Exames Moçambique Logger
 */
class Logger {
    static log(message) {
        console.log(`📜 Exames Moçambique: ${message}`);
    }
};

export default Logger;